export default __webpack_public_path__ + "static/media/is_this_you_s.f6901582.jpg";